import * as tslib_1 from "tslib";
import { OnInit, } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseLicensePage } from '@components/shared/license/base.license.page';
import { WARNING_LEVELS } from '@components/shared/license/license.constants';
import { LicenseOfficeType, } from '@models';
import { licenseOfficeType, LicenseUrlMap, SignalRService, } from '@services';
import { switchMap, takeUntil, throttleTime, } from 'rxjs/operators';
var LicensePageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LicensePageComponent, _super);
    function LicensePageComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.officeTypeDefinition = LicenseOfficeType;
        _this.warningLevels = WARNING_LEVELS;
        _this._signalRService = _this._injector.get(SignalRService);
        return _this;
    }
    Object.defineProperty(LicensePageComponent.prototype, "type", {
        get: function () {
            return LicenseUrlMap[this._type];
        },
        set: function (type) {
            var mappedtype = (type || '').toLowerCase();
            if (this._type === mappedtype) {
                return;
            }
            this._type = mappedtype;
            this._cd.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LicensePageComponent.prototype, "officeType", {
        get: function () {
            return licenseOfficeType(LicenseUrlMap[this._type]);
        },
        enumerable: true,
        configurable: true
    });
    LicensePageComponent.prototype.ngOnInit = function () {
        var _this = this;
        var route = this._injector.get(ActivatedRoute);
        route.paramMap
            .pipe(takeUntil(this._destroyed$))
            .subscribe(function (params) { return _this.type = params.get('type'); });
        if (!this._type) {
            // make sure we have fresh data on overview
            this._appState.user.license
                .fetch()
                .subscribe();
        }
        this._signalRService.licenseUsage$
            .pipe(throttleTime(150), switchMap(function () { return _this._appState.user.license.fetch(); }), takeUntil(this._destroyed$))
            .subscribe(function () {
            _this._cd.detectChanges();
        });
    };
    LicensePageComponent.prototype.onRemove = function (payload) {
        this._onRemove(payload.deactivate && !payload.hostLicenseId);
    };
    return LicensePageComponent;
}(BaseLicensePage));
export { LicensePageComponent };
